<div class="ai-chat-container">

  <!-- Header -->
  <div class="ai-chat-header">
    <div class="header-left">
      <div class="ai-avatar" [class.pulsing]="isStreaming">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="2" y="8" width="20" height="12" rx="3"></rect>
          <path d="M8 8V6a4 4 0 0 1 8 0v2"></path>
          <circle cx="8.5" cy="14" r="1.5" fill="currentColor" stroke="none"></circle>
          <circle cx="15.5" cy="14" r="1.5" fill="currentColor" stroke="none"></circle>
          <path d="M10 17.5h4"></path>
          <path d="M12 2v2"></path>
        </svg>
      </div>
      <div class="header-info">
        <h2 class="header-title">{{ 'aiAssistant.title' | translate }}</h2>
        <span class="header-sub">
          <span class="status-dot" [class.streaming]="isStreaming"></span>
          {{ isStreaming ? ('aiAssistant.typing' | translate) : ('aiAssistant.subtitle' | translate) }}
        </span>
      </div>
    </div>
    <div class="header-actions">
      <button class="btn-clear" (click)="clearChat()" [disabled]="messages.length === 0" [title]="'aiAssistant.clearChat' | translate">
        <i class="fa-solid fa-broom"></i>
      </button>
    </div>
  </div>


  <!-- Messages -->
  <div class="messages-area" #messagesContainer>

    <!-- Empty state -->
    <div class="empty-state" *ngIf="messages.length === 0">
      <div class="empty-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="2" y="8" width="20" height="12" rx="3"></rect>
          <path d="M8 8V6a4 4 0 0 1 8 0v2"></path>
          <circle cx="8.5" cy="14" r="1.5" fill="currentColor" stroke="none"></circle>
          <circle cx="15.5" cy="14" r="1.5" fill="currentColor" stroke="none"></circle>
          <path d="M10 17.5h4"></path>
          <path d="M12 2v2"></path>
        </svg>
      </div>
      <h3>{{ 'aiAssistant.welcome.title' | translate }}</h3>
      <p>{{ 'aiAssistant.welcome.description' | translate }}</p>
      <div class="suggestions">
        <button
          class="suggestion-btn"
          *ngFor="let key of suggestionKeys"
          (click)="useSuggestion(key)">
          <i class="fa-regular fa-lightbulb"></i>
          {{ key | translate }}
        </button>
      </div>
    </div>

    <!-- Message list -->
    <div class="messages-list" *ngIf="messages.length > 0">
      <div
        class="message-wrapper"
        *ngFor="let msg of messages; let i = index; trackBy: trackByIndex"
        [class.user-msg]="msg.role === 'user'"
        [class.assistant-msg]="msg.role === 'assistant'">

        <div class="msg-avatar" *ngIf="msg.role === 'assistant'">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="2" y="8" width="20" height="12" rx="3"></rect>
            <path d="M8 8V6a4 4 0 0 1 8 0v2"></path>
            <circle cx="8.5" cy="14" r="1.5" fill="currentColor" stroke="none"></circle>
            <circle cx="15.5" cy="14" r="1.5" fill="currentColor" stroke="none"></circle>
            <path d="M10 17.5h4"></path>
            <path d="M12 2v2"></path>
          </svg>
        </div>

        <div class="msg-bubble">
          <div class="msg-content">
            <!-- Thinking state: waiting for first token -->
            <span class="typing-dots" *ngIf="msg.streaming && !msg.content">
              <span></span><span></span><span></span>
            </span>
            <!-- Content + inline cursor while streaming -->
            <ng-container *ngIf="msg.content">
              <span [innerHTML]="msg.content | formatAiText"></span><span class="cursor-blink" *ngIf="msg.streaming">▋</span>
            </ng-container>
          </div>
          <div class="msg-footer">
            <span class="msg-time">{{ msg.timestamp | date:'HH:mm' }}</span>
            <button
              class="btn-copy"
              *ngIf="msg.role === 'assistant' && !msg.streaming && msg.content"
              (click)="copyMessage(msg.content, i)"
              [title]="'aiAssistant.copy' | translate">
              <i class="fa-regular" [class.fa-copy]="copiedIndex !== i" [class.fa-check]="copiedIndex === i"></i>
            </button>
          </div>
        </div>

        <div class="msg-avatar user-avatar" *ngIf="msg.role === 'user'">
          <i class="fa-solid fa-user-nurse"></i>
        </div>

      </div>
    </div>

  </div>

  <!-- Input area -->
  <div class="input-area">
    <div class="input-wrapper">
      <textarea
        #textInput
        class="msg-input"
        [(ngModel)]="inputText"
        (keydown)="onKeydown($event)"
        (input)="autoResizeInput()"
        [placeholder]="'aiAssistant.inputPlaceholder' | translate"
        [disabled]="isStreaming"
        rows="1">
      </textarea>
      <div class="input-actions">
        <button class="btn-stop" *ngIf="isStreaming" (click)="stopStreaming()" [title]="'aiAssistant.stopStreaming' | translate">
          <i class="fa-solid fa-stop"></i>
        </button>
        <button class="btn-send" *ngIf="!isStreaming" (click)="send()" [disabled]="!inputText.trim()">
          <i class="fa-solid fa-paper-plane"></i>
        </button>
      </div>
    </div>
    <p class="disclaimer">
      <i class="fa-solid fa-circle-info"></i>
      {{ 'aiAssistant.disclaimer' | translate }}
    </p>
  </div>

</div>
